// extracted by mini-css-extract-plugin
export default {"NewJobworkPage":"NewJobworkPage_NewJobworkPage__hXVOk"};